<template>
 <div class="ChatMobileFilterDialog">
  <div>
   <el-dialog :visible.sync="filter_dialog_visible" :before-close="handleClose">
    <div class="filter-header">
     <div>{{ filter_title }}</div>
    </div>

    <div class="filter-section-title">
     <span class="border-bottom relative">Filters</span>
     <span class="input-label-gray cursor-pointer" @click="resetFilter()">reset all</span>
    </div>

    <div class="filter-section">
     <div v-for="(filter, index) in filters" :key="index">
      <div
       class="filter-toggle-content"
       :class="{
        'active-menu-bgColor': active_index_title == filter.title,
       }"
      >
       <div class="filter-title" @click="showSubMenues(filter.title)">
        {{ filter.title }}
        <i v-if="active_index_title == filter.title" class="el-icon-minus"></i>
        <i v-else class="el-icon-plus"></i>
       </div>
       <div v-if="active_index_title == filter.title">
        <div v-for="(filter, index1) in filter.filter" :key="index1">
         <el-checkbox-group v-model="checked_filters" @change="applyFilter()">
          <el-checkbox class="filter-tab" :label="filter"></el-checkbox>
         </el-checkbox-group>
        </div>
       </div>
      </div>
     </div>
    </div>
   </el-dialog>

   <!-- <div class="mobile-filter-icon-section" v-if="isPremiumUser">
       <img src="../assets/images/company/filter_icon.svg" title="Filter" class="mobile-filter-icon"
         @click="openFilterDialog()" />
     </div> -->
  </div>
 </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import { EventBus } from '../eventBus';
import { HelperNetworkCallBack } from '../mixins/Helper';

export default {
 name: 'ChatMobileFilterDialog',

 mixins: [HelperNetworkCallBack],

 props: ['filters', 'filter_title'],

 data() {
  return {
   filter_dialog_visible: false,
   checked_filters: [],
   active_index_title: 'Skills',
   filter_obj: {
    filters: [],
    stocks: [],
    sector: '',
    target_period: {},
    term: '',
   },
   // appliedFilters: [],
  };
 },

 mounted() {
  EventBus.$on('openFilterDialog', this.openMobileFilterPopup);
 },

 methods: {
  showSubMenues(title) {
   console.log(title);

   // compared activeIndexTitle & title, if its both same then closed active menu & is not then open current title of submenus.
   if (this.active_index_title == '') {
    this.active_index_title = title;
   } else if (this.active_index_title == title) {
    this.active_index_title = '';
   } else {
    this.active_index_title = title;
   }
  },

  openMobileFilterPopup() {
   this.filter_dialog_visible = true;
  },

  mouseOver() {
   let body = document.getElementsByTagName('body')[0];
   body.style.overflow = 'hidden';
  },

  mouseLeave() {
   let body = document.getElementsByTagName('body')[0];
   body.style.overflow = 'auto';
  },

  applyFilter() {
   this.filter_obj.filters = this.checked_filters;
   EventBus.$emit('emitSelectedFilters', this.filter_obj);
   this.filter_dialog_visible = false;
  },

  resetFilter() {
   EventBus.$emit('clearedSelectedFilter', this.filter_obj);
   // EventBus.$emit("emitSelectedFilters", this.filter_obj);
   this.filter_dialog_visible = false;
  },

  clearFields(title) {
   EventBus.$emit('emitSelectedFilters', this.filter_obj);
   this.filter_dialog_visible = false;
  },

  //close filter dialog
  handleClose(done) {
   this.filter_dialog_visible = false;
  },
 },

 computed: {
  userProfile() {
   return JSON.parse(localStorage.getItem('profile'));
  },
 },

 beforeDestroy() {
  EventBus.$off();
 },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

@media screen and (max-width: 880px) {
 .ellipsis {
  max-width: 100px;
 }
}

@media screen and (max-width: 600px) {
 .dropdown-ellipsis {
  max-width: 190px;
 }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.el-dialog__title {
 color: $secondary-theme-color;
 font-size: 1rem;
}

.ChatMobileFilterDialog .el-dialog {
 position: absolute;
 bottom: 0;
 left: 0;
 right: 0;
 margin: 0 auto;
 border-radius: 10px 10px 0 0;
 background-color: $filter-section-background-color;
}

.ChatMobileFilterDialog .filter-section {
 background-color: #f7f8fc;
}

.ChatMobileFilterDialog .filter-section-title {
 display: flex;
 justify-content: space-around;
 font-weight: 500;
 padding: 25px 0;
}

.ChatMobileFilterDialog .filter-header {
 padding-top: 20px;

 div {
  text-align: center;
  border-radius: 20px;
  border: 1px solid #000;
  font-size: 0.8rem;
  font-weight: 600;
  color: #000;
  padding: 5px 20px;
  width: fit-content;
  margin: 0 auto;
 }
}

.ChatMobileFilterDialog .border-bottom:after {
 position: absolute;
 bottom: -30px;
 left: 13px;
 width: 22px;
 height: 2px;
 margin-bottom: 25px;
 content: '';
 -webkit-transform: translateX(-50%);
 transform: translateX(-50%);
 background-color: $primary-theme-color;
}

.filter-toggle-content {
 padding: 15px 20px;
 border-bottom: 1px solid #ddd;
}

.ChatMobileFilterDialog .filter-title {
 font-size: 0.8rem;
 font-weight: 600;
 display: flex;
 align-items: center;
 justify-content: space-between;
 cursor: pointer;

 .el-icon-plus,
 .el-icon-minus {
  font-size: 0.5rem;
  font-weight: 600;
 }
}

.filter-tab {
 display: block;
 margin-top: 10px;
}

.ChatMobileFilterDialog .active-menu-bgColor {
 background: $filter-section-background-color;
}

// search stock input css start
.ChatMobileFilterDialog .search-input {
 width: 100%;
}

// filters input type css start
.ChatMobileFilterDialog .el-input--small .el-input__inner {
 border-radius: 25px !important;
 background: transparent !important;
 border-color: #797979 !important;
 color: #797979;
}

.ChatMobileFilterDialog .el-radio__label {
 color: black;
 font-size: 0.8rem;
 font-weight: 400;
}

.ChatMobileFilterDialog .el-input__inner::placeholder {
 color: #89898a;
}

.ChatMobileFilterDialog .el-select .el-input .el-select__caret {
 /* Internet Explorer */
 color: #89898a;
}

.ChatMobileFilterDialog .el-checkbox__inner {
 background-color: #dcdfe6;
}

.ChatMobileFilterDialog .el-checkbox__label {
 text-transform: capitalize;
 font-size: 13px;
 color: #000;
 font-weight: 400;
}

.ChatMobileFilterDialog .range-dropdown {
 display: flex;
 align-items: center;
 justify-content: space-between;
}

.ChatMobileFilterDialog .range-dropdown small {
 width: 100px;
 text-align: right;
 margin-right: 10px;
}

.ChatMobileFilterDialog .range-dropdown .el-input--mini .el-input__inner {
 border-radius: 5px !important;
 border-color: #797979;
 background: transparent;
}

@media screen and (max-width: 1283px) {
 .ChatMobileFilterDialog .el-dialog {
  width: 90%;
 }

 .ChatMobileFilterDialog .el-dialog__body {
  padding: 0px 20px 20px 20px;
 }
}
</style>
<style lang="scss">
.ChatMobileFilterDialog .el-select--mini {
 width: 100% !important;
 margin: 0 10px;
}
</style>
